import { render, staticRenderFns } from "./CostBearersInfo.vue?vue&type=template&id=43b0020a"
import script from "./CostBearersInfo.vue?vue&type=script&lang=ts"
export * from "./CostBearersInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports